import Config from 'react-native-config';
import {findKey, get, keys} from 'lodash';

import {pageSize} from '/constant/data.constant';
import {PAGE_SIZE_FIELD_NAME} from '/enum/apiFields.enum';
import {CLIENT_JOURNEY_STATE_IS_LOADING} from '/enum/clientJourneyState.enum';
import {WEEKLY_CHECK_INS} from '/enum/clientJourneyTasks.enum';
import {CLIENT_NOTES_STATE_IS_LOADING} from '/enum/clients.enum';
import {
  ORDER_STATE_IS_LOADING,
  ORDERS_STATE_IS_LOADING,
} from '/enum/ordersState.enum';
import {
  CLIENT_TO_CONTACT_REPORT_ENUM,
  NEXT_TASK,
} from '/enum/peopleToContact.enum';
import {
  CLIENT_JOURNEY_ALL_TASKS,
  CLIENT_JOURNEY_TASKS,
  FETCH_CLIENT,
  FETCH_CLIENT_BODY_MEASUREMENTS,
  FETCH_CLIENT_MEAL_PLAN,
  FETCH_CLIENT_MY_WHY,
  FETCH_CLIENT_ORDER,
  FETCH_CLIENT_ORDERS,
  FETCH_CLIENT_START_DATE,
  FETCH_CLIENT_WEIGHT_GRAPH_DETAILS,
  FETCH_CLIENTS_ALERTS,
  FETCH_COACH_SHARE_PLAN,
  FETCH_MSWL_HEALTH_ROOT_PROFILE,
  FETCH_MWL_HEALTH_ROOT_PROFILE,
  REQUEST_POST,
  REQUEST_PUT,
} from '/enum/request.enum';
import {request} from '/redux/api/request';
import {createPromisedAction} from '/util/action.util';
import {getAccessTokenMule} from '/util/fetch.util';

import {getErrorHandler} from './apiError.action';
import {resetReport} from './report.action';
import {
  resetClientProfile,
  resetCoachProfile,
} from './sharedCoachClient.action';
//import {getStorageMuleToken} from './sfmc.action';

export const GET_PROFILE: string = 'CLIENT/GET_PROFILE';
export const GET_ORDERS: string = 'CLIENT/GET_ORDERS';
export const SET_ORDERS_STATE: string = 'CLIENT/SET_ORDERS_STATE';
export const GET_ORDER: string = 'CLIENT/GET_ORDER';
export const SET_ORDER_STATE: string = 'CLIENT/SET_ORDER_STATE';
export const GET_ALERTS: string = 'CLIENT/GET_ALERTS';
export const SET_DISMISSED_ALERTS: string = 'CLIENT/GET_DISMISSED_ALERTS';
export const SET_ALERTS_STATE: string = 'SET_ALERTS_STATE';
export const GET_CLIENT_JOURNEY_ALL_TASKS: string =
  'CLIENT/GET_CLIENT_JOURNEY_ALL_TASKS';
export const GET_CLIENT_JOURNEY_TASKS: string =
  'CLIENT/GET_CLIENT_JOURNEY_TASKS';
export const SET_CLIENT_JOURNEY_TASKS_DATA: string =
  'CLIENT/SET_CLIENT_JOURNEY_TASKS_DATA';
export const FETCH_CLIENT_JOURNEY_TASKS: string =
  'CLIENT/FETCH_CLIENT_JOURNEY_TASKS';
export const SET_CLIENT_JOURNEY_STATE: string =
  'CLIENT/SET_CLIENT_JOURNEY_STATE';
export const GET_FIRST_ORDER: string = 'CLIENT/GET_FIRST_ORDER';
export const UPDATE_CLIENT_PROFILE: string = 'CLIENT/UPDATE_CLIENT_PROFILE';

export const SET_CLIENT_NOTES_STATE: string = 'CLIENT/SET_CLIENT_NOTES_STATE';
export const GET_MWL_HEALTH_ROOT_PROFILE: string =
  'COACH/COACH_SHARING_PROFILE';
export const GET_MSWL_HEALTH_ROOT_PROFILE: string = 'COACH/MSWL';
export const GET_CLIENT_WEIGHT_GRAPH_DETAILS: string = 'COACH/WEIGHT_DETAILS';
export const GET_CLIENT_BODY_MEASUREMENTS: string = 'COACH/BODYMEASUREMENTS';
export const GET_CLIENT_STARTDATE: string = 'USER/JOURNEYPROFILE/STARTDATE';
export const GET_CLIENT_PLAN_DETAILS: string =
  'USER/JOURNEYPROFILE/PLANDETAILS';
export const GET_CLIENT_MY_WHY: string = 'USER/JOURNEYPROFILE/MYWHY';
export const GET_COACH_SHARE_PLAN: string = '/coach';

const muleHeaderContentType = 'application/json';
const muleHeaderAuthToken = Config.MULE_HEADER_AUTH_TOKEN;

export const headers = {
  'Content-Type': muleHeaderContentType,
  Authorization: muleHeaderAuthToken,
};

export const getProfile = createPromisedAction(
  GET_PROFILE,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;
    return request(FETCH_CLIENT, {body: {id: clientId}})
      .then(client => dispatchMe(() => ({clientId, client})))
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getProfile,
          params: inputPayload,
        }),
      );
  },
);

export const getOrders = createPromisedAction(
  GET_ORDERS,
  ['clientId', 'orderParams', 'appendData'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId, orderParams, appendData} = inputPayload;
    return (
      Promise.resolve()
        .then(() =>
          // Before fetching orders, first set the "isLoading" state to true.
          dispatch(
            setOrdersState({
              clientId,
              stateName: ORDERS_STATE_IS_LOADING,
              stateValue: true,
            }),
          ),
        )
        .then(() =>
          // Make the request to fetch orders.
          request(FETCH_CLIENT_ORDERS, {
            body: {id: clientId, ...orderParams},
            getHeaders: ['report-count'],
          }),
        )
        // @ts-expect-error TS(2339): Property 'data' does not exist on type '{ data: nu... Remove this comment to see the full error message
        .then(({data, responseHeaders}) =>
          dispatchMe(() => {
            const requestPageSize =
              get(orderParams, PAGE_SIZE_FIELD_NAME) ?? pageSize;
            const total = responseHeaders[0];

            return {
              clientId,
              orders: data,
              meta: {
                isEndReached: data.length < requestPageSize,
                sortParams: orderParams,
                page: {
                  total,
                },
              },
              appendData,
            };
          }),
        )
        .then(() =>
          // Finally set the "isLoading" state back to false.
          dispatch(
            setOrdersState({
              clientId,
              stateName: ORDERS_STATE_IS_LOADING,
              stateValue: false,
            }),
          ),
        )
        .catch(
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          getErrorHandler(dispatch, {
            promisedAction: getOrders,
            params: inputPayload,
          }),
        )
    );
  },
);

export const getOrder = createPromisedAction(
  GET_ORDER,
  ['orderId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {orderId} = inputPayload;
    return Promise.resolve()
      .then(() =>
        // Before fetching order, first set the "isLoading" state to true.
        dispatch(
          setOrderState({
            orderId,
            stateName: ORDER_STATE_IS_LOADING,
            stateValue: true,
          }),
        ),
      )
      .then(() =>
        // Make the request to fetch order.
        request(FETCH_CLIENT_ORDER, {body: {id: orderId}}),
      )
      .then(res =>
        // Call `dispatchMe` to dispatch this action with fetched order.
        dispatchMe(() => ({
          orderId,
          order: res,
        })),
      )
      .then(() =>
        // Finally set the "isLoading" state back to false.
        dispatch(
          setOrderState({
            orderId,
            stateName: ORDER_STATE_IS_LOADING,
            stateValue: false,
          }),
        ),
      )
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getOrder,
          params: inputPayload,
        }),
      );
  },
);

export const getFirstOrder = createPromisedAction(
  GET_FIRST_ORDER,
  ['firstOrderId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {firstOrderId} = inputPayload;
    return Promise.resolve()
      .then(() =>
        // Make the request to fetch order.
        request(FETCH_CLIENT_ORDER, {body: {id: firstOrderId}}),
      )
      .then(res =>
        dispatchMe(() => ({
          firstOrderId,
          order: res,
        })),
      )
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getOrder,
          params: inputPayload,
        }),
      );
  },
);

export const getAlerts = createPromisedAction(
  GET_ALERTS,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;
    return request(FETCH_CLIENTS_ALERTS, {body: {id: clientId}})
      .then(alerts => dispatchMe(() => ({clientId, alerts})))
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getAlerts,
          params: inputPayload,
        }),
      );
  },
);

export const dismissAlert = createPromisedAction(
  SET_DISMISSED_ALERTS,
  [
    'lastOrderedOn',
    'orderId',
    'premierOrderId',
    'rewardId',
    'latestExpiryDate',
    'clientId',
    'type',
    'dismissStatus',
    'allReportData',
  ],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (_dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {
      lastOrderedOn,
      orderId,
      premierOrderId,
      rewardId,
      latestExpiryDate,
      clientId,
      type,
      dismissStatus,
      allReportData,
    } = inputPayload;
    return Promise.resolve()
      .then(() =>
        // Before fetching alerts, first set the "isLoading" state to true.
        dispatch(
          setAlertsState({
            clientId,
            type,
            stateValue: true,
          }),
        ),
      )
      .then(() =>
        request(FETCH_CLIENTS_ALERTS, {
          method: REQUEST_POST,
          body: {
            clientId,
            dismissStatus,
            lastOrderedOn,
            orderId,
            premierOrderId,
            rewardId,
            latestExpiryDate,
          },
          params: {type},
        }),
      )
      .then(() =>
        dispatch(
          getAlerts({
            clientId,
          }),
        ),
      )
      .then(() => {
        // It is necessary to clear all previous sorting so that after the successful
        // cancellation of one alert, this report is displayed correctly
        const reportsKeys = keys(allReportData);
        const currentKey = findKey(
          CLIENT_TO_CONTACT_REPORT_ENUM,
          (arg: any) => arg === type,
        );
        const filteredReportsKeys = reportsKeys.filter((key: any) =>
          key.startsWith(currentKey),
        );
        filteredReportsKeys.forEach((element: any) => {
          dispatch(
            resetReport({
              reportKey: element,
              data: null,
            }),
          );
        });
      })
      .then(() =>
        dispatch(
          setAlertsState({
            clientId,
            type,
            stateValue: false,
          }),
        ),
      )
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getAlerts,
          params: inputPayload,
        }),
      );
  },
);

export const setOrdersState = createPromisedAction(SET_ORDERS_STATE, [
  'clientId',
  'stateName',
  'stateValue',
]);

export const setOrderState = createPromisedAction(SET_ORDER_STATE, [
  'orderId',
  'stateName',
  'stateValue',
]);

export const setAlertsState = createPromisedAction(SET_ALERTS_STATE, [
  'clientId',
  'type',
  'stateName',
  'stateValue',
]);

export const getClientJourneyAllTasks = createPromisedAction(
  GET_CLIENT_JOURNEY_ALL_TASKS,
  [],
  // @ts-expect-error TS(2345): Argument of type '(dispatchMe: any, inputPayload: ... Remove this comment to see the full error message
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;
    return request(CLIENT_JOURNEY_ALL_TASKS, {
      body: {},
    })
      .then(res => {
        dispatchMe(() => ({clientId, allTasks: res}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getClientJourneyAllTasks,
          params: inputPayload,
        }),
      );
  },
);

export const getClientJourneyTasks = createPromisedAction(
  GET_CLIENT_JOURNEY_TASKS,
  ['type', 'clientId', 'currentDate'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {type, clientId, currentDate} = inputPayload;
    const getParams = () => {
      let params;
      if (type === WEEKLY_CHECK_INS) {
        params = {clientId, type, currentDate};
      } else {
        params = {clientId, type};
      }
      return params;
    };
    return request(CLIENT_JOURNEY_TASKS, {
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 3.
      body: getParams(clientId, type, currentDate),
    })
      .then(tasks => {
        dispatchMe(() => ({clientId, type, tasks}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getClientJourneyTasks,
          params: inputPayload,
        }),
      );
  },
);

export const setClientJourneyTasks = createPromisedAction(
  SET_CLIENT_JOURNEY_TASKS_DATA,
  ['type', 'clientId', 'tasks'],
);

export const setClientJourneyState = createPromisedAction(
  SET_CLIENT_JOURNEY_STATE,
  ['clientId', 'type', 'stateName', 'stateValue'],
);

export const fetchClientJourneyTask = createPromisedAction(
  FETCH_CLIENT_JOURNEY_TASKS,
  ['type', 'clientId', 'task'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {type, clientId, task, reportData} = inputPayload;
    return Promise.resolve()
      .then(() =>
        request(CLIENT_JOURNEY_TASKS, {
          body: task,
          params: {clientId, type},
          method: REQUEST_POST,
        }),
      )
      .then(status => {
        dispatchMe(() => ({clientId, type, status}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchClientJourneyTask,
          params: inputPayload,
        }),
      )
      .then(() => {
        // Calling next task api to reload the updated data
        const reportsKeys = keys(reportData);
        const currentKey = findKey(
          CLIENT_TO_CONTACT_REPORT_ENUM,
          (arg: any) => arg === NEXT_TASK,
        );
        const filteredReportsKeys = reportsKeys.filter((key: any) =>
          key.startsWith(currentKey),
        );
        filteredReportsKeys.forEach((element: any) => {
          dispatch(
            resetReport({
              reportKey: element,
              data: null,
            }),
          );
        });
      })
      .then(() =>
        // Finally set the loading state back to false.
        dispatch(
          setClientJourneyState({
            clientId,
            type,
            stateName: CLIENT_JOURNEY_STATE_IS_LOADING,
            stateValue: false,
          }),
        ),
      )
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: resetReport,
          params: reportData,
        }),
      );
  },
);
export const setClientNotesState = createPromisedAction(
  SET_CLIENT_NOTES_STATE,
  ['clientId', 'stateName', 'stateValue'],
);
export const updateClientNotes = createPromisedAction(
  UPDATE_CLIENT_PROFILE,
  ['clientId', 'body'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId, body} = inputPayload;
    return Promise.resolve()
      .then(() =>
        // Finally set the loading state back to false.
        dispatch(
          setClientNotesState({
            clientId,
            stateName: CLIENT_NOTES_STATE_IS_LOADING,
            stateValue: true,
          }),
        ),
      )
      .then(() =>
        request(FETCH_CLIENT, {
          URLParams: JSON.stringify(clientId),
          body: body,
          method: REQUEST_PUT,
        }),
      )
      .then(client => {
        dispatchMe(() => ({clientId, client}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: updateClientNotes,
          params: inputPayload,
        }),
      )
      .then(() => {
        // Calling client api to reload the updated data
        dispatch(resetClientProfile({clientId}));
      })
      .then(() => {
        // Calling coachId api to reload the updated data
        dispatch(resetCoachProfile({coachId: clientId}));
      })
      .then(() => {
        // Calling client api to reload the updated data
        dispatch(getProfile({clientId}));
      })
      .then(() =>
        // Finally set the loading state back to false.
        dispatch(
          setClientNotesState({
            clientId,
            stateName: CLIENT_NOTES_STATE_IS_LOADING,
            stateValue: false,
          }),
        ),
      )
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: resetClientProfile,
          params: clientId,
        }),
      );
  },
);
export const fetchMwlhr = createPromisedAction(
  GET_MWL_HEALTH_ROOT_PROFILE,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;

    return request(FETCH_MWL_HEALTH_ROOT_PROFILE, {
      body: {customer_id: clientId},
      isHealthyHabits: true,
    })
      .then(data => {
        dispatchMe(() => ({customer_id: clientId, data}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchMwlhr,
          params: inputPayload,
        }),
      );
  },
);

export const fetchMSWLHR = createPromisedAction(
  GET_MSWL_HEALTH_ROOT_PROFILE,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;

    return request(FETCH_MSWL_HEALTH_ROOT_PROFILE, {
      body: {customer_id: clientId},
      isHealthProfile: true,
    })
      .then(data => {
        dispatchMe(() => ({customer_id: clientId, data}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchMSWLHR,
          params: inputPayload,
        }),
      );
  },
);
export const fetchWeightGraph = createPromisedAction(
  GET_CLIENT_WEIGHT_GRAPH_DETAILS,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;
    return request(FETCH_CLIENT_WEIGHT_GRAPH_DETAILS, {
      body: {customer_id: clientId},
      isHealthyHabits: true,
    })
      .then(data => {
        dispatchMe(() => ({customer_id: clientId, data}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchWeightGraph,
          params: inputPayload,
        }),
      );
  },
);
export const fetchBodyMeasurements = createPromisedAction(
  GET_CLIENT_BODY_MEASUREMENTS,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;

    return request(FETCH_CLIENT_BODY_MEASUREMENTS, {
      body: {customer_id: clientId, show_gains: true},
      isHealthProfile: true,
    })
      .then(data => {
        dispatchMe(() => ({customer_id: clientId, data}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchBodyMeasurements,
          params: inputPayload,
        }),
      );
  },
);
export const fetchstartDate = createPromisedAction(
  GET_CLIENT_STARTDATE,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;

    return getAccessTokenMule()
      .then(token => {
        return request(FETCH_CLIENT_START_DATE, {
          body: {
            access_token: token,
            source: 'COACH_APP',
            customerId: clientId,
          },
          muleHeaders: headers,
          isMuleApi: true,
        });
      })
      .then(data => {
        dispatchMe(() => ({customerId: clientId, data}));
      })
      .catch(error => {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchstartDate,
          params: inputPayload,
        })(error);
      });
  },
);

export const fetchplanDetails = createPromisedAction(
  GET_CLIENT_PLAN_DETAILS,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;

    return getAccessTokenMule()
      .then(token => {
        return request(FETCH_CLIENT_MEAL_PLAN, {
          body: {
            access_token: token,
            source: 'COACH_APP',
            customerId: clientId,
          },
          muleHeaders: headers,
          isMuleApi: true,
        });
      })
      .then(data => {
        dispatchMe(() => ({customerId: clientId, data}));
      })
      .catch(error => {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchplanDetails,
          params: inputPayload,
        })(error);
      });
  },
);

export const fetchmyWhy = createPromisedAction(
  GET_CLIENT_MY_WHY,
  ['clientId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {clientId} = inputPayload;

    return getAccessTokenMule()
      .then(token => {
        return request(FETCH_CLIENT_MY_WHY, {
          body: {
            access_token: token,
            source: 'COACH_APP',
            customerId: clientId,
          },
          muleHeaders: headers,
          isMuleApi: true,
        });
      })
      .then(data => {
        dispatchMe(() => ({customerId: clientId, data}));
      })
      .catch(error => {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchmyWhy,
          params: inputPayload,
        })(error);
      });
  },
);

export const fetchShareOptaviaPlan = createPromisedAction(
  GET_COACH_SHARE_PLAN,
  ['coachId'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {coachId} = inputPayload;
    return getAccessTokenMule()
      .then(token => {
        return request(FETCH_COACH_SHARE_PLAN, {
          body: {
            access_token: token,
            source: 'COACH_APP',
          },
          muleHeaders: headers,
          isMuleApi: true,
        });
      })
      .then((data: {replicatedSiteInfo?: {coachAlias?: string}}) => {
        const {replicatedSiteInfo: {coachAlias = ''} = {}} = data ?? {};
        dispatchMe(() => ({coachAlias, coachId}));
      })
      .catch(error => {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: fetchShareOptaviaPlan,
          params: inputPayload,
        })(error);
      });
  },
);
